import React from "react";

// reactstrap components
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  Table,
  Input
} from "reactstrap";

class Settings extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      objects:[
        {
          name:"AmbientHumidity",
          poll:"10",
          min:"0",
          max:"100",
        },
        {
          name:"UV",
          poll:"10",
          min:"0",
          max:"100",
        },
        {
          name:"AmbientTemp",
          poll:"10",
          min:"0",
          max:"100",
        },
        {
          name:"BarometerMoisture",
          poll:"10",
          min:"0",
          max:"100",
        },
        {
          name:"SoilTemp",
          poll:"10",
          min:"0",
          max:"100",
        },
        {
          name:"SoilMoisture",
          poll:"10",
          min:"0",
          max:"100",
        },
        {
          name:"BarometerTemp",
          poll:"10",
          min:"0",
          max:"100",
        },
        {
          name:"WindSpeed",
          poll:"10",
          min:"0",
          max:"100",
        },
        {
          name:"BarometerPressure",
          poll:"10",
          min:"10",
          max:"10",
        },
      ]
    }
  };
  render() {
    const row = this.state.objects.map((item, index) => (
        <tr key={index}>
            <td>{item.name}</td>
            <td><Input type="Number" Value={item.min} style={{width:"100px"}}/></td>
            <td><Input type="Number" Value={item.max} style={{width:"100px"}}/></td>
            <td><Input type="Number" Value={item.poll} style={{width:"100px"}}/></td>
        </tr>
    ))
    return (
      <>
      <div className="content">
        <Card className="card-chart">
          <CardHeader>
            <CardTitle tag="h3">
              Demo Node
            </CardTitle>
          </CardHeader>
          <CardBody>
            <Table responsive>
              <thead>
                <tr>
                  <th>Sensor</th>
                  <th>Min Threshold</th>
                  <th>Min Threshold</th>
                  <th>Poll Rate (seconds)</th>
                </tr>
              </thead>
              <tbody>
                {row}
              </tbody>
            </Table>
          </CardBody>
        </Card>
      </div>
      </>
    );
  }
}

export default Settings;
